import { createApp } from 'vue'
import Tangent from './Tangent.vue'
import './assets/global.css'

createApp(Tangent).mount('#tangent')
